/* Keep section navigation and reading anchors below the existing adaptive header. */
(() => {
  const navigation = document.querySelector('.ho-inspiration-navigation');
  if (!navigation || navigation.dataset.observed) return;
  navigation.dataset.observed = 'true';
  const header = document.querySelector('.ho-header');
  const update = () => {
    document.documentElement.style.setProperty('--inspiration-shell-height', `${header?.getBoundingClientRect().height || 0}px`);
    document.documentElement.style.setProperty('--inspiration-nav-height', `${navigation.getBoundingClientRect().height}px`);
  };
  const observer = new ResizeObserver(update);
  if (header) observer.observe(header);
  observer.observe(navigation);
  update();
})();

/* Progressive enhancement: recipe and worksheet content remains usable without JS. */
(() => {
 const preparePrint=()=>document.querySelectorAll('[data-note]').forEach(field=>{field.nextElementSibling.textContent=field.value||'—';});
 window.addEventListener('beforeprint',preparePrint);
 document.querySelectorAll('[data-print]').forEach(button => button.addEventListener('click', () => {preparePrint();window.print();}));
 document.querySelectorAll('[data-recipe]').forEach(recipe => {
  const select = recipe.querySelector('[data-servings]');
  const format = value => { const whole=Math.floor(value), fraction=Math.round((value-whole)*8); const symbols=['','⅛','¼','⅜','½','⅝','¾','⅞']; return fraction===0 ? String(whole) : (whole ? whole+' ' : '') + symbols[fraction]; };
  const update = () => {recipe.querySelector('[data-recipe-yield]').textContent=select.value+' side portions';recipe.querySelectorAll('[data-quantity]').forEach(item => { item.textContent = format(Number(item.dataset.quantity) * Number(select.value) / Number(recipe.dataset.baseServings)); });};
  select.addEventListener('change', update); update();
 });
 document.querySelectorAll('[data-worksheet]').forEach(sheet => {
  const key = 'hearth-inspiration-notes-v1:' + sheet.dataset.worksheet;
  const fields = [...sheet.querySelectorAll('[data-note]')];
  const status = sheet.querySelector('[data-save-status]');
  try { const saved = JSON.parse(localStorage.getItem(key) || '{}'); fields.forEach(field => { field.value = typeof saved[field.dataset.note] === 'string' ? saved[field.dataset.note] : ''; }); } catch { status.textContent = 'Browser storage is unavailable. Download your notes before leaving.'; }
  sheet.addEventListener('input', () => { try { localStorage.setItem(key, JSON.stringify(Object.fromEntries(fields.map(field => [field.dataset.note, field.value])))); status.textContent = 'Saved in this browser.'; } catch { status.textContent = 'Could not save in this browser. Download your notes before leaving.'; } });
  sheet.querySelector('[data-clear]').addEventListener('click', () => { fields.forEach(field => {field.value='';}); try {localStorage.removeItem(key);} catch {} status.textContent='Notes cleared.'; });
  sheet.querySelector('[data-download]').addEventListener('click', async event => {
   const button=event.currentTarget; button.disabled=true; status.textContent='Preparing your PDF…';
   const loadScript=url=>new Promise((resolve,reject)=>{const script=document.createElement('script');script.src=url;script.onload=resolve;script.onerror=()=>{script.remove();reject(new Error('Download unavailable'));};document.head.append(script);});
   try {
    if(!window.jspdf) await loadScript(sheet.dataset.pdfVendor);
    if(!window.HearthNotesPDF) await loadScript(sheet.dataset.pdfDocument);
    const response=await fetch(sheet.dataset.pdfBrand);if(!response.ok)throw new Error('Brand assets unavailable');
    const brand=await response.json();
    const pdf=window.HearthNotesPDF(window.jspdf.jsPDF,brand,{title:sheet.dataset.articleTitle,subtitle:sheet.querySelector('h2').textContent,fields:fields.map(field=>({label:field.parentElement.firstChild.textContent.trim(),value:field.value}))});
    pdf.save('hearth-outpost-'+sheet.dataset.worksheet.split('/').pop()+'-notes.pdf');
    status.textContent='Your PDF is ready. Check your downloads.';
   } catch {status.textContent='Your PDF could not be prepared. Please try again. Your notes are still here.';}
   finally {button.disabled=false;}
  });
 });
})();

(() => {
 document.querySelectorAll('[data-cover-finder]').forEach(finder => {
  const brand=finder.querySelector('[data-cover-brand]'), query=finder.querySelector('[data-cover-query]'), rows=[...finder.querySelectorAll('[data-cover-row]')];
  const update=()=>{ const tokens=query.value.toLowerCase().trim().split(/\s+/).filter(Boolean); let count=0;
   rows.forEach(row=>{const match=(!brand.value || row.dataset.brand===brand.value) && tokens.every(token=>row.dataset.search.toLowerCase().includes(token)); row.hidden=!match; if(match) count++;});
   finder.querySelector('[data-cover-count]').textContent=count+' matching configuration'+(count===1?'':'s'); finder.querySelector('[data-cover-empty]').hidden=count!==0;
  };brand.addEventListener('change',update);query.addEventListener('input',update);
 });
})();

(() => {
 document.querySelectorAll('[data-article-filter]').forEach(group=>{
  const query=group.querySelector('[data-article-query]'), cards=[...group.querySelectorAll('.ho-editorial-card')];
  query.addEventListener('input',()=>{ const terms=query.value.toLowerCase().trim().split(/\s+/).filter(Boolean); let count=0;
   cards.forEach(card=>{const match=terms.every(term=>card.textContent.toLowerCase().includes(term));card.hidden=!match;if(match)count++;});
   group.querySelector('[data-article-count]').textContent=count+' matching article'+(count===1?'':'s');group.querySelector('[data-article-empty]').hidden=count!==0;
  });
 });
 /* Integration event only. No network requests, note text, search text or storage values. */
 document.querySelector('main')?.addEventListener('click',event=>{
  const target=event.target.closest('a,button'); if(!target)return;
  const action=target.matches('[data-download]')?'worksheet_download':target.matches('[data-print]')?'print':target.closest('[data-cover-row]')?'cover_reference_click':target.closest('.ho-product-card')?'product_click':target.closest('.ho-editorial-card')?'article_click':null;
  if(action)document.dispatchEvent(new CustomEvent('hearth:inspiration',{detail:{action,path:location.pathname,target:target.getAttribute('href')?.split('?')[0]||null}}));
 });
})();

/* Keep the current Inspiration page available when following website links. */
(() => {
 if(!document.querySelector('.ho-inspiration-navigation, .ho-inspiration-cover-intro, .ho-inspiration-hub-hero, .ho-inspiration-category-list, [data-inspiration-entrypoints]')) return;
 const update=anchor=>{
  if(anchor.closest('ho-header') || anchor.classList.contains('skip-link') || anchor.hasAttribute('download'))return;
  try {
   const url=new URL(anchor.getAttribute('href'),location.href);
   if(!['http:','https:'].includes(url.protocol))return;
   if(url.origin===location.origin || /^(www\.)?hearthoutpost\.com$/.test(url.hostname)){
    anchor.target='_blank';anchor.rel=[...new Set((anchor.rel+' noopener').trim().split(/\s+/))].join(' ');
   }
  }catch{}
 };
 document.querySelectorAll('a[href]').forEach(update);
 document.addEventListener('click',event=>{const anchor=event.target.closest('a[href]');if(anchor)update(anchor);},true);
})();
